<ng-container>
    <div>
      <div style="margin-left: 70%;  margin-bottom: 2%">
        <!-- <button
        [useExistingCss]="true"
          class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button color="primary"
          printSectionId="print-section" ngxPrint>
          print
        </button> -->

       <button class="noPrint"
        style="margin-right: 2%; margin-left: 2%"
        mat-raised-button color="primary"
        (click)="printPage()">
         Print
       </button>

        <button class="noPrint" style="margin-top: 2% 2% 0 2%;"
          (click)="exportExcel('Representativewise_Subscription_Bussiness_Report')" mat-raised-button color="primary">
          Export
        </button>
        <button mat-dialog-close class="btn noPrint">
          Close
        </button>
      </div>
    </div>
    <div>
      <div class="container" id="print-section">
        <table class="table table-bordered">
          <thead>

             <tr>
            <th [attr.colspan]="totalth - 0" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              हिंदुस्थान प्रकाशन संस्था - विवेक साप्ताहिक - वर्गणी विभाग
            </th>

            <th colspan="3" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              दिनांक - {{ today | date:'dd-MM-yyyy' }}
            </th>
          </tr>

            <tr>
            <th [attr.colspan]="totalth - 3" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील - प्रतिनिधीनुसार  अतिसंक्षिप्त 
               <span *ngIf="appliedFilters">
                    <small>
                        <!-- <span *ngIf="appliedFilters.country"> |<strong>देश:</strong>  {{ appliedFilters.country }}</span>
                        <span *ngIf="appliedFilters.state"> | <strong>राज्य:</strong> {{ appliedFilters.state }}</span>
                        <span *ngIf="appliedFilters.district"> |<strong>जिल्हा:</strong> {{ appliedFilters.district }}</span>
                        <span *ngIf="appliedFilters.taluka"> | <strong>तालुका:</strong> {{ appliedFilters.taluka }}</span>
                        <span *ngIf="appliedFilters.subscriptionType"> |<strong>वर्गणी प्रकार:</strong>  {{ appliedFilters.subscriptionType }}</span>
                        <span *ngIf="appliedFilters.rep"> | <strong>प्रतिनिधी: </strong> {{ appliedFilters.rep }}</span>
                        <span *ngIf="appliedFilters.officerep"> |<strong>कार्यालय प्रतिनिधी:</strong> {{ appliedFilters.officerep }}</span>
                        <span *ngIf="appliedFilters.prant"> | <strong>प्रांत:</strong> {{ appliedFilters.prant }}</span>
                        <span *ngIf="appliedFilters.receiptType"> | <strong>पावती प्रकार:</strong> {{ appliedFilters.receiptType }}</span> -->

                        
                        <span *ngIf="appliedFilters.country && appliedFilters.country.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>देश:</strong> <strong>{{ appliedFilters.country }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.state && appliedFilters.state.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>राज्य:</strong> <strong>{{ appliedFilters.state }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.district && appliedFilters.district.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>जिल्हा:</strong> <strong>{{ appliedFilters.district }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.taluka && appliedFilters.taluka.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>तालुका:</strong> <strong>{{ appliedFilters.taluka }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.subscriptionType && appliedFilters.subscriptionType.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>वर्गणी प्रकार:</strong> <strong>{{ appliedFilters.subscriptionType }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.rep && appliedFilters.rep.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>प्रतिनिधी:</strong> <strong>{{ appliedFilters.rep }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.officerep && appliedFilters.officerep.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>कार्यालय प्रतिनिधी:</strong> <strong>{{ appliedFilters.officerep }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.prant && appliedFilters.prant.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>प्रांत:</strong> <strong>{{ appliedFilters.prant }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.receiptType && appliedFilters.receiptType.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>पावती प्रकार:</strong> <strong>{{ appliedFilters.receiptType }}</strong>
                        </span>	 


                    </small>
                </span>
            </th>

            <th colspan="3" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              दिनांक - {{ startDate | date:'dd-MM-yyyy' }}
            </th>
            <th colspan="3" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              पर्यंत - {{ endDate | date:'dd-MM-yyyy' }}
            </th>
          </tr>



            <tr>
              <!-- <th rowspan="2">जिल्हा</th>
              <th rowspan="2">तालुका</th> -->
              <th rowspan="2" style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; word-wrap: break-word;">प्रतिनिधींचे नाव</th>
              <th colspan="4" style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">एकूण</th>
              <ng-container *ngFor="let data of subTypesName">
                <th *ngIf="data.isVisible" colspan="4" style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">{{ data.name }}</th>
                <!-- <th *ngIf="data.isVisible" rowspan="2">रक्कम रुपये</th> -->
              </ng-container>
            </tr>
            <tr>
  
              <th style="border-left: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black; word-wrap: break-word;">वर्गणीदार संख्या</th>
              <th style="border-bottom: 2px solid black; border-left: 2px solid black;">रक्कम</th>
              <th style="border-bottom: 2px solid black;">नवीन</th>
              <th style="border-bottom: 2px solid black; word-wrap: break-word;">नूतनीकरण</th>
              <!-- <th style="border-bottom: 2px solid black; word-wrap: break-word;">नूतनी-बाकी</th> -->
              <!-- <th style="border-bottom: 2px solid black;  border-left: 2px solid black;">नवीन एकूण</th> -->
              <!-- <th>रक्कम रुपये</th> -->
              <ng-container *ngFor="let data of subTypesName">
                <th *ngIf="data.isVisible" style="border-left: 2px solid black; border-bottom: 2px solid black;">नवीन</th>
                <th *ngIf="data.isVisible" style="border-bottom: 2px solid black; word-wrap: break-word;">नूतनीकरण</th>
                <th *ngIf="data.isVisible" style="border-bottom: 2px solid black;">एकूण</th>
                <th *ngIf="data.isVisible" style="border-bottom: 2px solid black; border-right: 2px solid black;">रक्कम</th>
                <!-- <th *ngIf="data.isVisible" style="border-right: 2px solid black; border-bottom: 2px solid black; word-wrap: break-word;">नूतनी-बाकी</th> -->
                <!-- <th *ngIf="data.isVisible" style="border-bottom: 2px solid black;">नवीन एकूण</th> -->
              </ng-container>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let data of finalData;  let i = index">
              <ng-container *ngIf=" i != finalData.length - 1">
               
                <ng-container >
                 
                  <tr *ngIf="!end1">
                    <td style="border-left: 2px solid black; border-left: 2px solid black; white-space: nowrap; overflow: hidden;" >{{ data['rep_name'] + ' - ' + data['rep_taluka'] }}</td>
                    <td style="text-align: right; border-left: 2px solid black; border-right: 1px solid black;">{{ data['sub'] }}</td>
                    <td style="text-align: right;">{{ data['एकूण'] }}</td>
                    <td style="text-align: right;">{{ data['नवीन'] }}</td>
                    <td style="text-align: right; border-right: 2px solid black;">  {{ (data['नूतनीकरण'] || 0) + (data['नूतनीकरणबाकी'] || 0) }}</td>
                    <!-- <td style="text-align: right; border-right: 2px solid black;">{{ data['नूतनीकरणबाकी'] }}</td> -->
                    <!-- <td style="text-align: right; border-right: 2px solid black;"> {{ (data['नवीन'] || 0) + (data['नूतनीकरण'] || 0) }}</td> -->
                    <ng-container *ngFor="let sub of subTypesName">
                      <ng-container *ngIf="sub.isVisible">
                        <td style="text-align: right; border-left: 2px solid black;">{{ data[getKey(sub.name)+ '_नवीन'] }}</td>
                        <td style="text-align: right;">{{ (data[getKey(sub.name)+ '_नूतनीकरण'] || 0) + (data[getKey(sub.name)+ '_नूतनीकरणबाकी'] || 0)}}</td>
                        <td style="text-align: right;">{{ (data[getKey(sub.name) + '_नवीन'] || 0) + (data[getKey(sub.name) + '_नूतनीकरण'] || 0) + (data[getKey(sub.name)+ '_नूतनीकरणबाकी'] || 0)}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{ data[getKey(sub.name)+ '_एकूण'] }}</td>
                        <!-- <td style="text-align: right; border-right: 2px solid black;">{{ data[getKey(sub.name)+ '_नूतनीकरणबाकी'] }}</td> -->
                        <!-- <td style="text-align: right;">{{ (data[getKey(sub.name) + '_नवीन'] || 0) + (data[getKey(sub.name) + '_नूतनीकरण'] || 0) }}</td> -->
                        
                      </ng-container>
                    </ng-container>
                  </tr>
                  <tr *ngIf="end1">
                    <td colspan="1" class="centerText">{{ data['name'] }}</td>
                    <td>{{ data['sub'] }}</td>
                    <td>{{ data['नवीन'] }}</td>
                    <td>{{ (data['नूतनीकरण'] || 0) + (data['नूतनीकरणबाकी'] || 0) }}</td>
                    <td>{{ data['एकूण'] }}</td>
                    <!-- <td>{{ data['नूतनीकरणबाकी'] }}</td> -->
                    <!-- <td>{{ (data['नवीन'] || 0) + (data['नूतनीकरण'] || 0) }}</td> -->
                    <ng-container *ngFor="let sub of subTypesName">
                      <ng-container *ngIf="sub.isVisible">
                        <td>{{ data[getKey(sub.name)+ '_नवीन'] }}</td>
                        <td>{{ (data[getKey(sub.name)+ '_नूतनीकरण'] || 0) + (data[getKey(sub.name)+ '_नूतनीकरणबाकी'] || 0) }}</td>
                        <td>{{ (data[getKey(sub.name) + '_नवीन'] || 0) + (data[getKey(sub.name) + '_नूतनीकरण'] || 0) + (data[getKey(sub.name)+ '_नूतनीकरणबाकी'] || 0)}}</td>
                        <td>{{ data[getKey(sub.name)+ '_एकूण'] }}</td>
                        <!-- <td>{{ data[getKey(sub.name)+ '_नूतनीकरणबाकी'] }}</td> -->
                        <!-- <td>{{ (data[getKey(sub.name) + '_नवीन'] || 0) + (data[getKey(sub.name) + '_नूतनीकरण'] || 0) }}</td> -->
                      </ng-container>
                    </ng-container>
                  </tr>
                </ng-container>
               
              </ng-container>
              <ng-container *ngIf="i === finalData.length - 1">
                <tr class="smallHeading">
                  <td colspan="1" style="text-align: right; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ data['name'] }}</td>
                  <td style="text-align: right; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">{{ data['sub'] }}</td>
                  <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ data['एकूण'] }}</td>
                  <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ data['नवीन'] }}</td>
                  <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">{{ (data['नूतनीकरण'] || 0) + (data['नूतनीकरणबाकी'] || 0) }}</td>
                  <!-- <td style="text-align: right; border-right: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">{{ data['नूतनीकरणबाकी'] }}</td> -->
                  <!-- <td> {{ (data['नवीन'] || 0) + (data['नूतनीकरण'] || 0) }}</td> -->

                  <!-- <td>{{ data['एकूण'] }}</td> -->
                  <ng-container *ngFor="let sub of subTypesName">
                    <ng-container *ngIf="sub.isVisible">
                      <td style="text-align: right; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">{{ data[getKey(sub.name)+ '_नवीन'] }}</td>
                      <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ (data[getKey(sub.name)+ '_नूतनीकरण'] || 0) + (data[getKey(sub.name)+ '_नूतनीकरणबाकी'] || 0)}}</td>
                      <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ (data[getKey(sub.name)+ '_नवीन'] || 0) + (data[getKey(sub.name) + '_नूतनीकरण'] || 0) + (data[getKey(sub.name)+ '_नूतनीकरणबाकी'] || 0)}}</td>
                      <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ data[getKey(sub.name)+ '_एकूण'] }}</td>
                      <!-- <td style="text-align: right; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{ data[getKey(sub.name)+ '_नूतनीकरणबाकी'] }}</td> -->
                      <!-- <td>{{ (data[getKey(sub.name)+ '_नवीन'] || 0) + (data[getKey(sub.name) + '_नूतनीकरण'] || 0) }}</td> -->
                    </ng-container>
                  </ng-container>
                </tr>
              </ng-container>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  
   
  </ng-container>
  <div *ngIf="isLoading" class="main-loading">
    <span class="loader"></span>
    <p>Loading...</p>
  </div>